import * as React from "react";

const SVGNoCardRequired = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.9">
        <circle cx="20" cy="20" r="20" fill="url(#paint0_linear_14_60)" />
        <circle
          cx="20"
          cy="20"
          r="19.5"
          stroke="url(#paint1_linear_14_60)"
          stroke-opacity="0.22"
        />
      </g>
      <path
        opacity="0.2"
        d="M11.25 17.0227H27.916L27.9165 24.6464C27.9165 24.8164 27.849 24.9795 27.7288 25.0997C27.6086 25.2199 27.4455 25.2874 27.2755 25.2874H11.8915C11.7215 25.2874 11.5584 25.2199 11.4382 25.0997C11.318 24.9795 11.2505 24.8164 11.2505 24.6464L11.25 17.0227Z"
        fill="var(--primary-theme-color)"
      />
      <path
        d="M27.2755 13.75H11.8915C11.5375 13.75 11.2505 14.037 11.2505 14.391V24.647C11.2505 25.001 11.5375 25.288 11.8915 25.288H27.2755C27.6295 25.288 27.9165 25.001 27.9165 24.647V14.391C27.9165 14.037 27.6295 13.75 27.2755 13.75Z"
        stroke="var(--primary-theme-color)"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.9419 22.7246H20.2239"
        stroke="var(--primary-theme-color)"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.25 17.0227H27.916"
        stroke="var(--primary-theme-color)"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26.8053 19.3054C25.6686 19.3054 24.5801 19.7645 23.7867 20.5785L23.5664 20.8045C22.7934 21.5976 22.3608 22.6612 22.3608 23.7686C22.3608 24.8949 22.8083 25.9751 23.6047 26.7715L23.7704 26.9372C24.5753 27.7421 25.667 28.1943 26.8053 28.1943C27.9436 28.1943 29.0352 27.7421 29.8401 26.9372L30.0059 26.7715C30.8023 25.9751 31.2497 24.8949 31.2497 23.7686C31.2497 22.6612 30.8171 21.5976 30.0442 20.8045L29.8239 20.5785C29.0305 19.7645 27.942 19.3054 26.8053 19.3054Z"
        fill="white"
        stroke="var(--primary-theme-color)"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.5833 23.75H25.0277"
        stroke="var(--primary-theme-color)"
        stroke-width="1.4"
        stroke-linecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_14_60"
          x1="0.885609"
          y1="20"
          x2="39.5572"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F4FFF7" />
          <stop offset="1" stop-color="#F4FFF7" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_14_60"
          x1="0.442805"
          y1="26.9231"
          x2="40.0012"
          y2="26.8806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--primary-theme-color)" />
          <stop offset="1" stop-color="var(--primary-theme-color)" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SVGNoCardRequired;
